import { cn } from "components/lib/utils";
import type { HTMLAttributes } from "react";

export function StageNumber({
  step,
  color = "grey",
  className,
}: {
  step: number;
  color?: "green" | "red" | "grey";
} & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "size-10 mb-2 flex justify-center items-center rounded-full border-3",
        color === "grey" ? "border-gray-200" : color === "green" ? "border-green-500" : "border-red-500",
        className
      )}>
      <p className="text-sm font-semibold">{step}</p>
    </div>
  );
}
